import isNil from 'lodash-es/isNil';

import { MINUTES_IN_HOUR, MS_IN_SECOND, SECONDS_IN_MINUTE } from '../../time-constants';

export function calculateLastNHoursOfferUntil({
  currentDate,
  offsetHours,
  lastStartDateStr,
}: {
  currentDate: Date;
  lastStartDateStr: string | null | undefined;
  offsetHours: number;
}): { offerUntil: string; shouldSaveCurrentTime: boolean } {
  const offsetInMs = offsetHours * MINUTES_IN_HOUR * SECONDS_IN_MINUTE * MS_IN_SECOND;
  const offerUntilBasedOnCurrentDate = new Date(currentDate.getTime() + offsetInMs).toISOString();
  if (isNil(lastStartDateStr)) {
    return { offerUntil: offerUntilBasedOnCurrentDate, shouldSaveCurrentTime: true };
  }

  const offerUntilBasedOnSavedValue = new Date(new Date(lastStartDateStr).getTime() + offsetInMs);
  const timeDiff = offerUntilBasedOnSavedValue.getTime() - currentDate.getTime();
  if (timeDiff <= 0) {
    return { offerUntil: offerUntilBasedOnCurrentDate, shouldSaveCurrentTime: true };
  }
  return { offerUntil: offerUntilBasedOnSavedValue.toISOString(), shouldSaveCurrentTime: false };
}
